var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('creative-lib', { attrs: { "resourceType": 9, "resourceClass": 1 } });
};
var staticRenderFns = [];

export { render, staticRenderFns };